<script async setup lang="ts">
import { CULTURE } from '@/composables/helpers'
import { cartStore, addCidToCartLocalStorage, removeCidFromCartLocalStorage, showAndHideEnquiryBox } from '@/store/cart.store'
import { HeartIcon } from '@heroicons/vue/24/outline'
import { computed, ref, watch } from 'vue'
import t from '@/i18n/translations'
import type { IAccoItem } from '@/composables/Interfaces/apiInterfaces'
import { width } from '@/composables/windowSize'
import { mediaBreakpointsAsNumber } from '@/constants'

const props = defineProps<{
  cid: number
}>()

const emit = defineEmits<{
  track: []
}>()

const showPopover = ref(false)
const maxCountCartStorage = 12

function addOrRemoveFromCartStorage(cid: number) {
  const accoFound = cartStore.value.accos.find((x: IAccoItem) => x.companyId === cid)

  if (!accoFound && cartStore.value.accos.length >= maxCountCartStorage) {
    showPopover.value = true
    return
  }

  showPopover.value = false

  if (accoFound) {
    removeCidFromCartLocalStorage(props.cid)
  } else {
    addCidToCartLocalStorage(props.cid)
    emit('track')
    if (width.value > mediaBreakpointsAsNumber.md) showAndHideEnquiryBox()
  }
}

const isMarkedAsFavorite = computed(() => {
  const accoFound = cartStore.value.accos.find((x: IAccoItem) => x.companyId === props.cid)
  return !!accoFound
})

watch(
  () => cartStore.value.accos.length,
  (newLength) => {
    if (newLength <= 11) {
      showPopover.value = false
    }
  }
)
</script>

<template>
  <div class="relative cursor-pointer">
    <div v-if="showPopover" class="absolute bottom-12 left-0 z-10 mt-2 w-64 rounded-lg border bg-white p-4 shadow-lg md:left-auto md:right-0">
      <div class="absolute -bottom-2 left-4 h-4 w-4 rotate-45 transform bg-white md:left-auto md:right-4"></div>
      <div class="flex flex-col md:text-left">
        <span class="font-sm font-semibold text-red-500">{{ t(`${CULTURE}.cart.errorMessage.maxCount`) }}</span>
        <span class="font-xs">{{ t(`${CULTURE}.cart.errorMessage.removeFromCart`) }}</span>
      </div>
    </div>
    <div
      @click.prevent.stop="addOrRemoveFromCartStorage(props.cid)"
      class="flex w-full justify-center gap-1 rounded border border-[var(--p-primary-contrast-color)] bg-[var(--p-primary-grey)] px-2 py-1 text-[var(--p-primary-contrast-color)] hover:brightness-95 md:bg-white"
    >
      {{ t(`${CULTURE}.acco[${isMarkedAsFavorite ? 'selected' : 'select'}]`) }}
      <HeartIcon class="relative my-auto size-5" :class="isMarkedAsFavorite ? 'fill-black' : 'fill-none'"></HeartIcon>
    </div>
  </div>
</template>
